/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class InfrastructureResourcesInventoryOverviewWidgetConfiguration extends models.BaseChartWidgetConfigurationModel {
    constructor() {
        super();
        this.setDiscriminator("InfrastructureResourcesInventoryOverviewWidgetConfiguration");
    }

    getFixupPrototypeFunction() { return InfrastructureResourcesInventoryOverviewWidgetConfiguration.fixupPrototype; }

    static newInstance(model: Partial<InfrastructureResourcesInventoryOverviewWidgetConfiguration>): InfrastructureResourcesInventoryOverviewWidgetConfiguration {
        let obj = Object.assign(new InfrastructureResourcesInventoryOverviewWidgetConfiguration(), model);
        InfrastructureResourcesInventoryOverviewWidgetConfiguration.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<InfrastructureResourcesInventoryOverviewWidgetConfiguration>): InfrastructureResourcesInventoryOverviewWidgetConfiguration {
        if (!model) return null;
        return InfrastructureResourcesInventoryOverviewWidgetConfiguration.newInstance(<InfrastructureResourcesInventoryOverviewWidgetConfiguration> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: InfrastructureResourcesInventoryOverviewWidgetConfiguration) {
        if (!obj) return;

        models.InfrastructureResourcesInventoryOverviewWidgetConfiguration.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: InfrastructureResourcesInventoryOverviewWidgetConfiguration): boolean {
        if (models.BaseChartWidgetConfigurationModel.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, InfrastructureResourcesInventoryOverviewWidgetConfiguration.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
